import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { getContactInfo } from "../services/contactService";

export default function Footer() {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    getContactInfo().then((res) => {
      setContact(res);
    });
  }, []);

  return (
    <footer className="bg-gray-900 text-gray-300 py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          
          {/* ✅ LOGO & DESCRIPTION */}
          <div className="md:w-1/3">
            <img
              src="/footer-logo.png"
              alt="Dev Sols Footer Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="leading-relaxed">
              Empowering businesses with cutting-edge technology solutions.
            </p>
          </div>

          {/* ✅ Quick Links + Social Links */}
          <div className="flex flex-col sm:flex-row gap-10 md:gap-16">
            <div>
              <h4 className="text-white font-semibold mb-3">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-white">Home</Link></li>
                <li><Link to="/services" className="hover:text-white">Services</Link></li>
                <li><Link to="/blogs" className="hover:text-white">Blogs</Link></li>
                <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              </ul>
            </div>

            {/* ✅ Social Links */}
            <div>
              <h4 className="text-white font-semibold mb-3">Follow Us</h4>
              <div className="flex gap-4">
                {contact?.fb_link && (
                  <a href={contact.fb_link} target="_blank" rel="noopener noreferrer"
                    className="p-2 rounded-full bg-gray-800 hover:bg-blue-600 transition">
                    <FaFacebookF size={18} />
                  </a>
                )}
                {contact?.insta_link && (
                  <a href={contact.insta_link} target="_blank" rel="noopener noreferrer"
                    className="p-2 rounded-full bg-gray-800 hover:bg-pink-500 transition">
                    <FaInstagram size={18} />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ✅ COPYRIGHT */}
        <div className="text-center mt-8 border-t border-gray-700 pt-4 text-sm">
          © {new Date().getFullYear()} Development Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
}